import React, { useState } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min.js";

import IRM_2 from "../assets/software/IRM_2.6.bat";
import imgVerAgente from "../assets/img/veragente.png";
import imgServidor from "../assets/img/cambiardirservidor.jpg";
import Agente from "../assets/software/ThefClien4.8.exe";

const urlDescargaAgente = "https://www.youtube.com/embed/LQtBOiJ50qU?si=oGMUkmZ-6B8DiMrO";
const urlAplicarPDP = "https://www.youtube.com/embed/ypw3f4RbtEA?si=zW-NyjywGLZgIxDT";
const videoArrProvincia = "https://www.youtube.com/embed/3vgZwCx4XXU?si=DEii-X6CPYh8XLga";

const SERVER_URL = "citd.dgp.educ.ar";

/* Helpers UI */
function VideoFrame({ src, title }) {
  return (
    <div className="ratio ratio-16x9 media-box shadow-sm">
      <iframe
        src={src}
        title={title}
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
        allowFullScreen
      />
    </div>
  );
}

export default function Descargas() {
  const [copied, setCopied] = useState(false);

  const copyServer = async () => {
    try {
      await navigator.clipboard.writeText(SERVER_URL);
      setCopied(true);
      setTimeout(() => setCopied(false), 1800);
    } catch {
      /* no-op */
    }
  };

  return (
    <div className="container py-3">
      {/* Header */}
      <div className="card border-0 shadow-sm rounded-4 mb-3">
        <div className="card-body p-3 p-md-4">
          <div className="d-flex align-items-center gap-3">
              <div className="icon-bubble rounded-circle bg-primary-subtle d-inline-flex align-items-center justify-content-center">
                <span className="material-symbols-outlined">download</span>
              </div>
            <div>
              <h2 className="h4 mb-1">Descargas</h2>
              <p className="text-secondary mb-0 small">
                Herramientas y recursos multimedia para el desbloqueo y arranques.
              </p>
            </div>
          </div>
        </div>
      </div>

      {/* Tabs (Bootstrap nativo) */}
      <ul
        className="nav nav-pills nav-fill gap-2 p-2 small bg-body-tertiary rounded-3 sticky-top"
        style={{ top: 0, zIndex: 10 }}
        id="descargasTab"
        role="tablist"
      >
        <li className="nav-item" role="presentation">
          <button
            className="nav-link active"
            id="provincia-tab"
            data-bs-toggle="pill"
            data-bs-target="#provincia-pane"
            type="button"
            role="tab"
            aria-controls="provincia-pane"
            aria-selected="true"
          >
            Provincia
            <div className="d-block opacity-75 fw-normal">Desbloqueo / Arranques</div>
          </button>
        </li>

        <li className="nav-item" role="presentation">
          <button
            className="nav-link"
            id="nacion-arranques-tab"
            data-bs-toggle="pill"
            data-bs-target="#nacion-arranques-pane"
            type="button"
            role="tab"
            aria-controls="nacion-arranques-pane"
            aria-selected="false"
          >
            Nación
            <div className="d-block opacity-75 fw-normal">Arranques (Agente)</div>
          </button>
        </li>
      </ul>

      <div className="tab-content mt-3" id="descargasTabContent">
        {/* ======= PROVINCIA ======= */}
        <div
          className="tab-pane fade show active"
          id="provincia-pane"
          role="tabpanel"
          aria-labelledby="provincia-tab"
          tabIndex="0"
        >
          <div className="card border-0 shadow-sm rounded-4">
            <div className="card-body p-3 p-md-4">
              <h3 className="h5 mb-3">Provincia — Desbloqueo / Arranques</h3>

              {/* Acciones rápidas */}
              <div className="d-grid d-sm-inline-flex gap-2 mb-3">
                <a className="btn btn-success btn-sm" href={IRM_2} download="IRM_2.6.bat">
                  Descargar IRM_2.6.bat
                </a>
              </div>

              {/* Paso 1 */}
              <div className="d-flex gap-3 align-items-start mb-3">
                <div className="rounded-circle bg-light border text-muted d-inline-flex justify-content-center align-items-center step-dot flex-shrink-0">
                  <span className="fw-semibold lh-1">1</span>
                </div>
                <div className="flex-grow-1">
                  Una vez desbloqueada la computadora, seguí estos pasos para dejarla operativa.
                </div>
              </div>

              {/* Paso 2 */}
              <div className="d-flex gap-3 align-items-start mb-2">
                <div className="rounded-circle bg-light border text-muted d-inline-flex justify-content-center align-items-center step-dot flex-shrink-0">
                  <span className="fw-semibold lh-1">2</span>
                </div>
                <div className="flex-grow-1">
                  Descargá el archivo y seguí las instrucciones del video.
                </div>
              </div>

              <div className="mt-3">
                <VideoFrame src={videoArrProvincia} title="Cargar arranques en 2 minutos (Provincia)" />
              </div>
            </div>
          </div>
        </div>

        {/* ======= NACIÓN — ARRANQUES ======= */}
        <div
          className="tab-pane fade"
          id="nacion-arranques-pane"
          role="tabpanel"
          aria-labelledby="nacion-arranques-tab"
          tabIndex="0"
        >
          <div className="card border-0 shadow-sm rounded-4">
            <div className="card-body p-3 p-md-4">
              <h3 className="h5 mb-3">Nación — Arranques (Agente)</h3>

              {/* Acciones rápidas */}
              <div className="d-grid d-sm-inline-flex gap-2 mb-3">
                <button className="btn btn-outline-secondary btn-sm" onClick={copyServer}>
                  Copiar URL del servidor ({SERVER_URL})
                </button>
                <a className="btn btn-success btn-sm" href={Agente} download="ThefClient4.8.exe">
                  Descargar agente
                </a>
              </div>

              {/* Paso 1 */}
              <div className="d-flex gap-3 align-items-start mb-3">
                <div className="rounded-circle bg-light border text-muted d-inline-flex justify-content-center align-items-center step-dot flex-shrink-0">
                  <span className="fw-semibold lh-1">1</span>
                </div>
                <div className="flex-grow-1">
                  Conectate a internet y abrí el <b>AGENTE</b> como se muestra a continuación.
                  <div className="mt-3">
                    <img src={imgVerAgente} className="media-img img-fluid" alt="Abrir agente" />
                  </div>
                </div>
              </div>

              {/* Paso 2 */}
              <div className="d-flex gap-3 align-items-start mb-3">
                <div className="rounded-circle bg-light border text-muted d-inline-flex justify-content-center align-items-center step-dot flex-shrink-0">
                  <span className="fw-semibold lh-1">2</span>
                </div>
                <div className="flex-grow-1">
                  En la pestaña <b>Configuración</b> verificá que el servidor apunte a:
                  <div className="mt-2 d-flex align-items-center gap-2 flex-wrap">
                    <code className="px-2 py-1 bg-light rounded-2">{SERVER_URL}</code>
                    <button className="btn btn-outline-secondary btn-sm" onClick={copyServer}>
                      Copiar URL
                    </button>
                  </div>
                  <div className="mt-3">
                    <img src={imgServidor} className="media-img img-fluid" alt="Servidor del agente" />
                  </div>
                </div>
              </div>

              {/* Paso 3: Collapse nativo Bootstrap */}
              <div className="d-flex gap-3 align-items-start mb-2">
                <div className="rounded-circle bg-light border text-muted d-inline-flex justify-content-center align-items-center step-dot flex-shrink-0">
                  <span className="fw-semibold lh-1">3</span>
                </div>
                <div className="flex-grow-1">
                  ¿No tenés el programa para cargar arranques?
                  <div className="mt-2">
                    <button
                      className="btn btn-outline-primary btn-sm"
                      type="button"
                      data-bs-toggle="collapse"
                      data-bs-target="#videoAgente"
                      aria-expanded="false"
                      aria-controls="videoAgente"
                    >
                      Ver cómo descargar e instalar el agente
                    </button>
                  </div>

                  <div className="collapse mt-3" id="videoAgente">
                    <VideoFrame src={urlDescargaAgente} title="Descargar e instalar el agente" />
                    <div className="mt-3">
                      <a className="btn btn-success btn-sm" href={Agente} download="ThefClient4.8.exe">
                        Descargar agente
                      </a>
                    </div>
                  </div>
                </div>
              </div>

              {/* (Opcional) Video tcopp si lo querés a mano en esta vista */}
              <div className="mt-4 d-none">
                <VideoFrame src={urlAplicarPDP} title="Cómo aplicar el paquete (tcopp)" />
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Toast Bootstrap-like (simple) */}
      <div
        className={`toast align-items-center text-bg-dark border-0 position-fixed ${copied ? "show" : "hide"}`}
        role="status"
        style={{ bottom: 16, right: 16, zIndex: 1080 }}
      >
        <div className="d-flex">
          <div className="toast-body small">URL copiada: {SERVER_URL}</div>
          <button type="button" className="btn-close btn-close-white me-2 m-auto" onClick={() => setCopied(false)} />
        </div>
      </div>
    </div>
  );
}
